import React, { useRef, useEffect } from "react";
import classNames from "classnames";
import ReactPhoneInput from "react-phone-input-2";

import getInputErrorClass from "utils/getInputErrorClass";

import InputErrorMessage from "../InputErrorMessage";

const DEFAULT_COUNTRY = "de";

function InputPhone({
  autoFocus = false,
  containerClass,
  labelClass,
  className,
  onChange,
  country = DEFAULT_COUNTRY,
  disabled,
  danger,
  label,
  name,
  error,
  formupData,
  enableErrorMessage = true,
  ...inputProps
}) {
  const inputRef = useRef();

  const labelClasses = classNames("form-label", labelClass);

  const inputClasses = classNames("text-lg text-black border border-grey-dark outline-none focus:border-secondary w-full rounded-sm pl-12 py-3", className, getInputErrorClass(error), {
    disabled,
    danger,
  });

  const containerClasses = classNames("form-group", className, containerClass, {
    danger,
  });

  const inputElementProps = {
    className: inputClasses,
    autoFocus,
    onChange,
    name,
  };

  useEffect(() => {
    if (inputRef?.current?.dropdownContainerRef) {
      inputRef.current.dropdownContainerRef.tabIndex = -1;
    }
  }, []);

  return (
    <div className={containerClasses}>
      {
        !!label && (
          <label htmlFor={name} className={labelClasses}>
            {label}
          </label>
        )
      }

      <ReactPhoneInput
        inputProps={inputElementProps}
        disabled={disabled}
        country={country}
        ref={inputRef}
        containerClass="mt-1"
        {...inputProps}
      />

      {
        enableErrorMessage && (
          <InputErrorMessage className="mt-1/2 leading-tight">
            {
              error && formupData?.errorMessage && (
                formupData?.errorMessage
              )
            }
            &nbsp;
          </InputErrorMessage>
        )
      }
    </div>
  );
}

export default InputPhone;
